module.exports = __webpack_public_path__ + "static/media/view.12db1c1e.svg";